var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.029 14.9173C25.029 16.1905 25.3445 16.9409 26.0387 17.8057C26.5649 18.4428 26.733 19.2606 26.733 20.1479C26.733 21.0341 26.46 21.8754 25.9131 22.5585C25.1971 23.3774 24.1874 23.9001 23.1569 23.991C21.6636 24.1268 20.1693 24.2411 18.6551 24.2411C17.1401 24.2411 15.6467 24.1727 14.1534 23.991C13.1219 23.9001 12.1122 23.3774 11.3972 22.5585C10.8503 21.8754 10.5764 21.0341 10.5764 20.1479C10.5764 19.2606 10.7454 18.4428 11.2706 17.8057C11.9866 16.9409 12.2813 16.1905 12.2813 14.9173V14.4854C12.2813 12.7803 12.6799 11.6653 13.5007 10.5739C14.7211 8.98213 16.6772 8.02748 18.6126 8.02748H18.6977C20.6746 8.02748 22.6941 9.02807 23.8937 10.6882C24.672 11.7572 25.029 12.8252 25.029 14.4854V14.9173ZM15.8735 26.3367C15.8735 25.8261 16.3127 25.5923 16.7189 25.4923C17.194 25.3851 20.0891 25.3851 20.5642 25.4923C20.9703 25.5923 21.4095 25.8261 21.4095 26.3367C21.3859 26.8227 21.1186 27.2535 20.7493 27.5272C20.2704 27.9253 19.7084 28.1775 19.1209 28.2684C18.796 28.3133 18.4767 28.3144 18.1631 28.2684C17.5746 28.1775 17.0126 27.9253 16.5347 27.5261C16.1644 27.2535 15.8971 26.8227 15.8735 26.3367Z",
    fill: "#9A9AA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6586 11.0687C27.6586 13.063 26.1505 14.6237 24.357 14.6237C22.5635 14.6237 21.0555 13.063 21.0555 11.0687C21.0555 9.07447 22.5635 7.51373 24.357 7.51373C26.1505 7.51373 27.6586 9.07447 27.6586 11.0687Z",
    fill: "#EB5757",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1b8554f7e150ef85c2c213d01996823a.svg";
export { ForwardRef as ReactComponent };